var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVendorPayFeeIcon = function SvgVendorPayFeeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AEAEAE",
    fillRule: "evenodd",
    d: "M14.006 2.715A8 8 0 0 0 0 8a8 8 0 1 0 16 0 8 8 0 0 0-.883-3.658l-6.702 6.745a.486.486 0 0 1-.685 0L4.336 7.669a.48.48 0 0 1 0-.684l.685-.683a.49.49 0 0 1 .686 0l2.365 2.393z"
  })));
};
export default SvgVendorPayFeeIcon;